import { useRestaurantDetails } from "../context/RestaurantDetailsContext";

export function getGstFractionFromEnv() {
  const fraction = Number(process.env.REACT_APP_GST_FRACTION);
  if (Number.isFinite(fraction) && fraction >= 0) return fraction;

  const percent = Number(process.env.REACT_APP_GST_PERCENT);
  if (Number.isFinite(percent) && percent >= 0) return percent / 100;

  return 0;
}

export function getLocaleFromEnv() {
  return process.env.REACT_APP_DEFAULT_LOCALE || "en-IN";
}

export function getRestaurantIdFromEnv() {
  return process.env.REACT_APP_DEFAULT_RESTAURANT_ID || "";
}

export function useRestaurantConfig() {
  const { restaurantDetails } = useRestaurantDetails() || {};

  const actualRestaurantId =
    restaurantDetails?.restaurant?._id;

  // console.log("🏪 RestaurantDetails object:", restaurantDetails);
  // console.log("🏪 Extracted Restaurant ID:", actualRestaurantId);

  const locale =
    restaurantDetails?.restaurant?.locale || getLocaleFromEnv();

  const restaurantId =
    actualRestaurantId || getRestaurantIdFromEnv();

  const gstFractionFromDb = Number(
    restaurantDetails?.restaurant?.gstRate
  );

  const gstFraction =
    Number.isFinite(gstFractionFromDb) && gstFractionFromDb >= 0
      ? gstFractionFromDb
      : getGstFractionFromEnv();

  const taxTypeFromDb = restaurantDetails?.restaurant?.taxType;
  const taxLabel =
    typeof taxTypeFromDb === "string" && taxTypeFromDb.trim()
      ? taxTypeFromDb.trim().toUpperCase()
      : "GST";

  const features = restaurantDetails?.restaurant?.features || {};

  const timezone =
    restaurantDetails?.restaurant?.timezone || "Asia/Kolkata";

  const nameObj = restaurantDetails?.restaurant?.name;
  const restaurantName = (nameObj && (nameObj.en || nameObj.ar)) || "Restaurant Name";

  return { locale, restaurantId, gstFraction, taxType: taxTypeFromDb, taxLabel, features, timezone, restaurantName };
}


